import Link from 'next/link';
import { Fragment, JSX } from 'react';

const LICENSES = [
    { label: 'Individual License', href: '/license/individual-license' },
    { label: 'Small Business License', href: '/license/small-business-license' },
    { label: 'Business License', href: '/license/business-license' },
];

export function AgreementText({ linkColorClassName = 'text-blue-700' }: { linkColorClassName?: string }): JSX.Element {
    const linkClassName = `${linkColorClassName} underline`;

    return (
        <>
            I have read and accept the{' '}
            <Link className={linkClassName} href="/terms-of-service">
                Terms of Service
            </Link>
            ,{' '}
            <Link className={linkClassName} href="/privacy">
                Privacy Policy
            </Link>
            , and the License Agreement that applies to my plan:{' '}
            {LICENSES.map(({ label, href }, index) => (
                <Fragment key={href}>
                    {index > 0 && ' / '}
                    <Link className={linkClassName} href={href}>
                        {label}
                    </Link>
                </Fragment>
            ))}
            .
        </>
    );
}
